import { Component, OnInit, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { PayPal, PayPalPayment, PayPalConfiguration } from '@ionic-native/paypal/ngx';

@Component({
  selector: 'app-paypal',
  templateUrl: './paypal.page.html',
  styleUrls: ['./paypal.page.scss'],
})
export class PaypalPage implements OnInit {

  @Input() importeAPagar;
  @Input() datos;

  private Sandbox_account: 'sb-5f1bi2681888@business.example.com'
  private Client_ID: 'AR7MkkoYqDpMwmzfZD583ZvUwFhci10IlV6P7W54q1jinYSK4QNJQ0uq0p-Zb3x405fCy-4RfXB50EOz'
  paymentAmount: string = '3.33';
  currency: string = 'EUR';
  currencyIcon: string = '€';
  constructor(
    private modalCtrl: ModalController,
    private payPal: PayPal,
    
  ) {
  
   }

  

  ngOnInit() {
    this.paymentAmount = this.importeAPagar;
  }
  salirModal(){
    this.modalCtrl.dismiss();
  }

  pagar(){
    this.payWithPaypal();
    /*this.modalCtrl.dismiss({
      confirmacion:'todo correcto o error',
      
      importe: 3
    });*/
  }
  payWithPaypal(){
    console.log("Pay ????");
    this.payPal.init({
      PayPalEnvironmentProduction: 'AR7MkkoYqDpMwmzfZD583ZvUwFhci10IlV6P7W54q1jinYSK4QNJQ0uq0p-Zb3x405fCy-4RfXB50EOz',
      PayPalEnvironmentSandbox: 'sb-5f1bi2681888@business.example.com'
    }).then(() =>{
      this.payPal.prepareToRender('sb-5f1bi2681888@business.example.com', new PayPalConfiguration({
        // Only needed if you get an "Internal Service Error" after PayPal login!
        //payPalShippingAddressOption: 2 // PayPalShippingAddressOptionPayPal
      })).then(() => {
        let payment = new PayPalPayment(this.paymentAmount, this.currency, 'Description', 'sale');
        this.payPal.renderSinglePaymentUI(payment).then((res) => {
          console.log(res);
          // Successfully paid

          // Example sandbox response
          //
          // {
          //   "client": {
          //     "environment": "sandbox",
          //     "product_name": "PayPal iOS SDK",
          //     "paypal_sdk_version": "2.16.0",
          //     "platform": "iOS"
          //   },
          //   "response_type": "payment",
          //   "response": {
          //     "id": "PAY-1AB23456CD789012EF34GHIJ",
          //     "state": "approved",
          //     "create_time": "2016-10-03T13:33:33Z",
          //     "intent": "sale"
          //   }
          // }
        }, () => {
          // Error or render dialog closed without being successful
        });
      }, () => {
        // Error in configuration
      });
    }, () => {
      // Error in initialization, maybe PayPal isn't supported or something else
    });
  }


  
}


